export function formatIsoDate(iso: string): string {
	const [year, month, day] = iso.split('-');
	if (!year || !month || !day) return iso;
	return `${day}/${month}/${year}`;
}

export function formatDayCount(days: number): string {
	if (days === 1) return '1 dia';
	return `${days} dias`;
}

export function formatRelativeDays(days: number): string {
	if (days === 0) return 'hoje';
	if (days === 1) return 'amanhã';
	if (days === -1) return 'ontem';
	if (days > 0) return `em ${formatDayCount(days)}`;
	return `há ${formatDayCount(Math.abs(days))}`;
}
